(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider, STATE_HELPER, TEMA_FORM_ADMIN) {
        var config = TEMA_FORM_ADMIN();
        var base = "admin/aulaDigital/tema";
        var params = {
            parent: "admin/aulaDigital/materia",
            view: 'contentChildren',
            base: base,
            baseUrl: "/{materiaid}/tema",
            translateBase: "aulaDigital.tema.admin.",
            templateList: '<tema-list-admin></tema-list-admin>',
            templateForm: config.component
        };

        var state = STATE_HELPER(params);
        // Estado Padre
        angular.merge(state.parent, {
            data: {
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content@': {
                    template: '<ng-include src="\'app/components/auladigital/admin/aula-digital-breadcrumb.admin.html\'"></ng-include>' +
                    '<div ui-view="contentChildren"></div>'
                }
            },
            resolve: {
                /* @ngInject */
                materia: function ($stateParams, Materia) {
                    // TODO: ¿Optimizar y obtener sólo ID y nombre?
                    if ($stateParams.materiaid) {
                        return Materia.get({id: $stateParams.materiaid}).$promise;
                    } else return {};
                }
            }
        });
        // Listar
        angular.merge(state.list, {});
        // Crear
        angular.merge(state.create, {
            resolve: config.resolve
        });
        // Editar
        angular.merge(state.edit, {
            resolve: angular.merge(config.resolve, {
                /* @ngInject */
                item: function (Tema, $stateParams) {
                    return Tema.get({id: $stateParams.id}).$promise;
                }
            })
        });

        // Se definen los estados
        $stateProvider
            .state(params.base, state.parent)
            .state(state.list.name, state.list)
            .state(state.create.name, state.create)
            .state(state.edit.name, state.edit);
    }
})();
